import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import "./AdminHospitalSettlement.css";

export default function AdminHospitalSettlementPage() {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [history, setHistory] = useState([]);
  const [showSettle, setShowSettle] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const fetchData = () => {
    axios.get("/admin/hospital-pharmacists/")
      .then(res => setData(res.data));
  };

  useEffect(() => {
    fetchData();
  }, []);


  const submitSettlement = () => {
    if (Number(amount) > selected.pending) {
      alert("Amount exceeds pending balance");
      return;
    }

    axios.post("/admin/hospital-settlements/", {
      pharmacist_id: selected.id,
      amount,
      note
    }).then(() => {
      setShowSettle(false);
      setAmount("");
      setNote("");
      fetchData();
    });
  };

  const openHistory = (p) => {
    axios.get(`/admin/hospital-settlements/${p.id}/`)
      .then(res => {
        setHistory(res.data);
        setShowHistory(true);
      });
  };

  return (
    <div className="admin-settlement-page">
      <h2>🏦 Hospital Pharmacist Settlements</h2>

      <table>
        <thead>
          <tr>
            <th>Pharmacist</th>
            <th>Hospital</th>
            <th>Earned</th>
            <th>Settled</th>
            <th>Pending</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {data.map(p => (
            <tr key={p.id}>
              <td>{p.name}</td>
              <td>{p.hospital}</td>
              <td>₹{p.total_earned}</td>
              <td>₹{p.total_settled}</td>
              <td className="pending">₹{p.pending}</td>
              <td>
                <button onClick={() => { setSelected(p); setShowSettle(true); }}>
                  Settle
                </button>
                <button onClick={() => openHistory(p)}>
                  History
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🔒 SETTLEMENT MODAL */}
      {showSettle && (
        <div className="modal">
          <div className="modal-box">
            <h3>Settle with {selected.name}</h3>

            <p>Pending: ₹{selected.pending}</p>

            <input
              type="number"
              placeholder="Settlement Amount"
              value={amount}
              onChange={e => setAmount(e.target.value)}
            />

            <textarea
              placeholder="Admin note (mandatory)"
              value={note}
              onChange={e => setNote(e.target.value)}
            />

            <div className="modal-actions">
              <button onClick={submitSettlement}>Confirm</button>
              <button onClick={() => setShowSettle(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* 📜 HISTORY MODAL */}
      {showHistory && (
        <div className="modal">
          <div className="modal-box large">
            <h3>Settlement History</h3>

            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Admin Note</th>
                </tr>
              </thead>
              <tbody>
                {history.map((h, i) => (
                  <tr key={i}>
                    <td>{new Date(h.date).toLocaleString()}</td>
                    <td>₹{h.amount}</td>
                    <td>{h.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button onClick={() => setShowHistory(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
